/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';

import DataSnippets from '@components/data-snippet';
import Icon from '@components/icon-component';
import InfoPopup from '@components/info-popup/info-popup.component';
import OpenLink from '@components/task-card-new/card-asset/open-link';
import { useOpenLink } from '@hooks/useOpenLink';

import style from './site-card.module.scss';
import { siteMapActions } from '@redux/slices/site-map';

const SiteCard = (props) => {
  const {
    siteDetailsCard = false,
    mapSiteCard = false,
    uwi,
    wellBore,
    typeData,
    showChevronIcon,
    onClickLink,
    to,
    title,
    subtitle,
    hideLocation,
    distance,
    unit,
    dataPoints,
    normal,
    allTasksForSite,
    allDoneTasks,
    isOverDue,
    status,
    childrenList,
    grey,
    highlight,
    highlightName,
    arrayText,
    open,
    moreInfo,
    setOpen,
    addChild,
    showWOCount,
    equipmentCount,
    pipelineCount,
    structureCount,
    link,
    recordIndicatorLength = 0,
    siteId,
    index,
    onInfoCLick,
    onBookmarkCLick,
    toDesktopLink,
    infoTabActive,
    otherTabsView,
    showInfoIcon
  } = props;
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { showMapView = false, selectedSiteIdForMapView } =
    useSelector((state) => state.siteMap) || {};
  const bookmarkId = searchParams.get('bookmarkId');

  const [desktopLink, setDesktopLink] = useState(null);

  const [openLink, setOpenLink] = useOpenLink({
    taskId: siteId,
    assetId: siteId
  });

  let [highlightNames, highlightType] = !_.isEmpty(highlight) ? highlight.split(' ') : [];
  highlightNames = highlightName ? highlight : highlightNames;

  if (!highlightType) highlightType = highlightNames;

  const onClickOpliiDesktopLinkEvent = (desktopLink) => {
    setDesktopLink({ linkValue: desktopLink });
    setOpenLink((prev) => !prev);
  };

  const siteCardInfo = () => {
    return (
      <>
        <div className={style.cardInner}>
          <div className={style.cardContent}>
            <div
              style={{
                position: 'relative'
              }}
            >
              <div style={{ position: 'relative' }}>
                <DataSnippets
                  allOnDemandRecordCount={props?.allOnDemandRecordCount || 0}
                  title={title || ''}
                  subtitle={subtitle || ''}
                  dataPoints={dataPoints}
                  iconName={!hideLocation && 'map-pin'}
                  kmValue={distance}
                  unit={unit || ''}
                  highlightNames={highlightNames}
                  highlightType={highlightType}
                  grey={grey}
                  siteDetailsCard={siteDetailsCard}
                  normal={normal}
                  allTasksForSite={allTasksForSite}
                  allDoneTasks={allDoneTasks}
                  isOverDue={isOverDue}
                  status={status}
                  childrenList={childrenList}
                  className={`${siteDetailsCard && style.noMargin}`}
                  showWOCount={showWOCount}
                  equipmentCount={equipmentCount}
                  pipelineCount={pipelineCount}
                  structureCount={structureCount}
                  link={link}
                  onClickOpliiDesktopLinkEvent={onClickOpliiDesktopLinkEvent}
                  recordIndicatorLength={recordIndicatorLength}
                  toDesktopLink={toDesktopLink}
                  inDetailView={siteDetailsCard}
                />
              </div>

              <OpenLink
                openLink={openLink}
                desktopLink={desktopLink}
                setOpenLink={setOpenLink}
                setDesktopLink={setDesktopLink}
                selectedLinkTypeIcon={'map-pin'}
                selectedLinkTypeName={'site'}
              />
            </div>

            {uwi && (
              <DataSnippets
                title={'Title'}
                subtitle={'Sub-Title'}
                type={'Type'}
                iconName={'maps'}
                kmValue={'23'}
                unit={'units'}
                siteIcon={style.siteIcon}
                className={style.marginClass}
              />
            )}
            {wellBore && (
              <DataSnippets
                title={'Title'}
                subtitle={'Sub-Title'}
                type={'Type'}
                iconName={'Equipment'}
                kmValue={'23'}
                unit={'units'}
                siteIcon={style.siteIcon}
                className={style.marginClass}
              />
            )}
            {typeData && (
              <DataSnippets
                title={'Title'}
                subtitle={'Sub-Title'}
                type={'Type'}
                iconName={'maps'}
                kmValue={'23'}
                unit={'units'}
                siteIcon={style.siteIcon}
                className={style.marginClass}
              />
            )}
            <>
              {addChild && <p className={`${style.moreChild}`}>{addChild}</p>}
              {showInfoIcon ? (
                infoTabActive ? (
                  <div
                    className={`${style.infoIcon} ${style.infoTabActive}`}
                    id="side-card-info-icon"
                  >
                    <Icon name="info-disabled" height={24} width={24} />
                  </div>
                ) : (
                  <div
                    className={`${style.infoIcon}`}
                    onClick={onInfoCLick}
                    id="side-card-info-icon"
                  >
                    <Icon name="info-icon-blue-stroke" height={24} width={24} />
                  </div>
                )
              ) : (
                <></>
              )}
            </>
          </div>
          {showMapView || mapSiteCard ? (
            <div
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                selectedSiteEvent();
              }}
            >
              <div className={style.mapLocationIcon}>
                <Icon
                  name={
                    selectedSiteIdForMapView.siteId === siteId
                      ? 'white-bg-location'
                      : 'blue-bg-location'
                  }
                  // className={`${style.siteIcon} `}
                  width="34px"
                  height={'34px'}
                />
              </div>
            </div>
          ) : showChevronIcon ? (
            <div>
              <div>
                <Icon name={'chevron-right'} className={style.siteIcon} width="10px" />
              </div>
            </div>
          ) : (
            <div>
              {showInfoIcon && (
                <div className={style.bookmarkIcon}>
                  {bookmarkId ? (
                    <Icon
                      name={'bookmarked-name'}
                      height={24}
                      width={24}
                      onClick={onBookmarkCLick}
                    />
                  ) : (
                    <Icon name={'bookmark-blue'} height={24} width={24} onClick={onBookmarkCLick} />
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </>
    );
  };

  const selectedSiteEvent = () => {
    dispatch(
      siteMapActions.setSelectedSiteIdOnMapView({
        siteId:
          selectedSiteIdForMapView?.siteId && selectedSiteIdForMapView?.siteId === siteId
            ? null
            : siteId,
        siteIndex:
          selectedSiteIdForMapView?.siteId && selectedSiteIdForMapView?.siteId === siteId
            ? -1
            : index
      })
    );
  };

  return showMapView || mapSiteCard ? (
    <Link
      className={`${style.cardWrapperNoHover} ${showMapView && style.mapViewPadding} ${
        selectedSiteIdForMapView.siteId === siteId && style.siteSelected
      } `}
      onClick={onClickLink}
      to={to}
    >
      {siteCardInfo()}
    </Link>
  ) : siteDetailsCard && !mapSiteCard ? (
    <div
      className={`${style.cardWrapperNoHover} ${props.className}`}
      style={{
        padding: siteDetailsCard ? '16px' : '',
        border: '0.5px solid #cbd2d9'
      }}
    >
      {siteCardInfo()}
    </div>
  ) : mapSiteCard ? (
    <div
      className={`${style.cardWrapperNoHover} ${showMapView && style.mapViewPadding} ${
        selectedSiteIdForMapView.siteId === siteId && style.siteSelected
      } `}
      onClick={selectedSiteEvent}
    >
      {siteCardInfo()}
    </div>
  ) : (
    <Link className={`${style.cardWrapper}`} onClick={onClickLink} to={to}>
      {siteCardInfo()}
    </Link>
  );
};

SiteCard.propTypes = {};

export default SiteCard;
